module.exports = __webpack_public_path__ + "media/images/logo-twitter-193df9f99b4f1a2a8e396113fd759006.svg";